module.exports = __webpack_public_path__ + "img/upload_cta.a18bc222.png";